class TestimonialsSlider extends HTMLElement {
  connectedCallback() {
    const swiperElement = this.querySelector('.testimonials__slider');
    if (!swiperElement || typeof Swiper === 'undefined') return;

    // Get settings from data attributes
    const showDots = this.getAttribute('data-show-dots') === 'true';
    const enableAutoplay = this.getAttribute('data-enable-autoplay') === 'true';
    const autoplayDelay = parseInt(this.getAttribute('data-autoplay-delay') || 5000, 10);

    const swiperOptions = {
      slidesPerView: 1.5,
      centeredSlides: false,
      loop: true,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 20,
      pagination: showDots ? {
        el: '.testimonials__swiper-pagination',
        clickable: true
      } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false
      } : false,
      breakpoints: {
        480: {
          slidesPerView: 1.5,
          centeredSlides: false,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1.5,
          centeredSlides: false,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.4,
          centeredSlides: true,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.4,
          centeredSlides: true,
          spaceBetween: 32,
        },
        1280: {
          slidesPerView: 3.4,
          centeredSlides: true,
          spaceBetween: 32,
        }
      }
    };

    new Swiper(swiperElement, swiperOptions);
  }
}

customElements.define('testimonials-slider', TestimonialsSlider); 